"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultMegaMenuTranslate = void 0;
exports.defaultMegaMenuTranslate = {
    popularBuilding: "Popular Buildings",
    popularDistrict: "Popular Districts",
    viewAllForSale: "View All For Sale",
    viewAllForRent: "View All For Rent",
    newDevelopments: "New Developments",
    featured: "Featured",
    information: "Information",
    rent: "Rent",
    buy: "Buy",
    list: "List",
    ourExclusive: "Our Exclusives",
    joinAsAnAgent: "Join As An Agent",
    joinNow: "Join Now",
    findAnAgent: "Find An Agent",
    contactUs: "Contact Us",
    enquiry: "Enquiry",
    agents: "Agents",
    aboutUs: "About Us",
    ourCompany: "Our Company",
    ourStory: "Our Story",
    ourTeam: "Property Agents",
    executiveTeam: "Executive Team",
    testimonials: "Testimonials",
    inThePress: "In The Press",
    callUsAt: "Call us at",
    callNumber: "+852 2102 0888",
    emailUsAt: "Email us",
    emailAddress: "cs@okay.com",
    resources: "Resources",
    newsAndInsights: "News & Insights",
    askAnAgent: "Ask An Agent",
    guides: "Guides",
    mortgage: "Mortgage Calculator",
    propertyGuides: "Property Guides",
    hkDistrictGuides: "Hong Kong District Guides",
    usefulInfo: "Useful Information",
    myAccount: "My Account",
    signIn: "Sign In",
    createAccount: "Create Account",
    favorite: "Favorite",
    savedProperties: "Saved Properties",
    savedSearches: "Saved Searches",
    recentlyViewed: "Recently Viewed",
    english: "English",
    language: "Language",
    traditionalChinese: "繁體中文",
    simplifiedChinese: "简体中文",
    personalDetails: "Personal Details",
    changePassword: "Change Password",
    alerts: "Alerts",
    myplaces: "My Places",
    logout: "Logout",
    unverified: "Unverified",
    forSale: "For Sale",
    forRent: "For Rent",
    pendingDocument: "Pending Documents",
    signedDocument: "Signed Documents",
    mylisting: "My Listings",
    myviewing: "My Viewings",
    buildingLayout: "Building Types",
    viewAllDistricts: "View All Districts",
    viewAllBuildings: "View All Buildings",
    viewAllArticles: "View All Articles",
    latestArticles: "Latest Articles",
};
